import store from 'app-components/utils/redux-store';

import { authActions, authSelectors } from 'app-components/flux/auth';
import { bumpInterface } from 'app-components/flux/bump';
import { featureFlagsSelectors } from 'app-components/flux/feature-flags';
import { requireEnvironmentConfig } from 'app-components/utils/core';

import { getIsOffline } from 'data/app/selectors';

bumpInterface.bumpInterfaceInit({
  create: () => {
    const socket = new WebSocket(requireEnvironmentConfig().websocket_qcs_url);
    socket.onclose = bumpInterface.onClose;
    socket.onerror = bumpInterface.onError;
    socket.onmessage = bumpInterface.onMessage;
    socket.onopen = bumpInterface.onOpen;
    return socket;
  },
  isOffline: () => (store ? getIsOffline(store.getState()) : true),
  reconnectTimeout: () => {
    if (!store) {
      return false;
    }
    const state = store.getState();
    return (
      authSelectors.isAuthenticatedWithDataSetId(state) &&
      featureFlagsSelectors.getFeatureFlag(store.getState(), 'webSocketQcs')
    );
  },
  reAuth: () => store?.dispatch(authActions.invalidateAccessToken(undefined, { context: 'WS auth failed' })),
});

setInterval(bumpInterface.checkSocketConnection, 30000);
